import React from 'react';
import PropTypes from 'prop-types';

const Services = ({ gridItems }) => (
  <div className='columns is-multiline'>
    { gridItems.map( item => {
        return (
          <div key={item.image} className='column is-6 is-flex'>
            <div className='section'  style={{ border: '1px solid #89898966', borderRadius: '5px'}}>
              <h2 className='has-text-centered title is-2'>{item.servHeader}</h2>
              <p className='has-text-centered'>
                <img alt='' src={item.image}/>
              </p>
              <p>{item.text}</p>
              <p><a href={item.servLink}>More information</a></p>
            </div>
          </div>
        );
      })
    }
  </div>
);

Services.propTypes = {
  gridItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      text: PropTypes.string,
      servHeader: PropTypes.string,
      servLink: PropTypes.string
    })
  ),
};

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services/index.js